/**
 * Public API for the rules registry system.
 */

// Re-export types
export type { Rule, Language, Category, Severity } from './types';

// Re-export functions
export {
  getGlobalManifest,
  getLanguageManifest,
  getLanguages,
  getLanguage,
  getCategoriesByLanguage,
  getCategory,
  getRulesByLanguage,
  getRulesByCategory,
  getRule,
  getSimilarRules,
  getAllRules,
  getRegistryStats,
  rules, // Backward compatibility
} from './loader';

// Re-export UI config functions
export { getLanguageUIConfig, getCategoryUIConfig } from './ui-config';
